import {
  toastSuccess,
  toastError,
} from 'components/ToastComponent/ToastComponent'
import { gaEvent } from 'utils/ga'
import * as providers from './provider'

export default setVisitScheduleModal => {
  const setField = (field, value) => {
    setVisitScheduleModal(prev => ({
      ...prev,
      form: { ...prev.form, [field]: value },
    }))
  }

  const sendForm = async (
    propertyId,
    form,
    saleType,
    propertySmallId,
    checkOffers,
    checkOffersResale
  ) => {
    const [err, res] = await providers.sendForm(
      propertyId,
      form,
      checkOffers,
      checkOffersResale
    )

    // @TODO Check error handling
    if (!res || err) {
      toastError('Não foi possível agendar a visita.')
      return false
    }
    gaEvent({
      category: 'V_Visita',
      action: 'submit',
      label: propertySmallId,
    })
    toastSuccess('Sua solicitação de visita foi agendada com sucesso!')
    return res
  }

  const setOpenModal = async () => {
    setVisitScheduleModal(prev => ({ ...prev, openModal: !prev.openModal }))
  }

  return {
    setField,
    sendForm,
    setOpenModal,
  }
}
